'use client'

import Script from 'next/script'

export const MarketingData = () => {
	return (
		<Script
			strategy='afterInteractive'
			src='https://storage.yandexcloud.net/creditclub-frontend/static/marketing_data.js'
		/>
	)
}
